import { graphql } from '~/lib/graphql'

export const ValidateDiscountCoupon = graphql(`
  query ValidateDiscountCoupon($input: DiscountCouponValidationInput!) {
    validateDiscountCoupon(input: $input) {
      __typename
      ... on DiscountCoupon {
        code
        name
        discountAmount
        minimumReservationAmount
        viewerAcquired
        reservablePeriod {
          from
          to
        }
        visitablePeriod {
          from
          to
        }
        usableMemberCount
      }
      ... on DiscountCouponValidationError {
        message
      }
    }
  }
`)
